<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
import { PremiumCalculator } from "@/types/premiumTypes";

defineProps<{
  subscriptionName: PremiumCalculator;
}>();
const emit = defineEmits(["showSubscribeModal"]);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col text-left content-container flex-wrap gap-y-4">
    <p class="bold-text">
      {{ t(`subscription.${subscriptionName}.name`) }}
    </p>
    <div class="flex items-center justify-between">
      <p class="bold-text">
        {{ t("subscription.plans.free") }}
      </p>
      <button
        class="bg-orange-gradient text-white px-4 py-2 rounded-full max-[422px]:w-full max-[422px]:h-11"
        @click="emit('showSubscribeModal')"
      >
        {{ t("buttons.subscription.get-subscription") }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.content-container {
  @apply px-4 py-3 border border-muted rounded-[20px];
}
.bold-text {
  @apply text-black font-semibold text-xl leading-[24px];
}
</style>
